
const aboutbalMLD = {
    "About MLD": [
        {
          question: "What is the issue date and the maturity date of the MLDs?",
          answer: "The MLD issue will be open for investors on Bidd from 11th Aug’23 to 30th Aug’23 and the maturity date is 31st Aug’25. The primary MLD issue date is 11th Aug’23."
        },
        {
          question: "What is the Underlying in this MLD?",
          answer: "The underlying in this MLD is the Nifty 50 Index with a participation ratio of 1.0x. This means that if the Nifty returns are 20%, the returns on the MLD would also be 20%."
        },
        {
          question: "What are the Minimum assured and the Maximum returns?",
          answer: "The Minimum assured returns  would be 14% and the maximum returns will be 30%. The returns are calculated on the Face Value of ₹1,00,000."
        },
        {
          question: "Which dates will be considered for calculating the returns of Nifty?",
          answer: "The Nifty Returns will be calculated based on the Initial Fixing Level and the Final Fixing Level. The date of the Initial Fixing Level is 31st Aug’23 and the Final Fixing level would be average of the levels of the Nifty 50 Index as on 26th Jun’25 & 31st Jul’25."
        },
        {
          question: "When will I receive the coupon (returns) on the MLDs?",
          answer: "The coupon will be realised at the Maturity of the MLD."
        },
        {
          question: "Is the MLD listed, secured and Credit Rated?",
          answer: "The MLD will be listed on BSE within 4 trading days of the Primary issue, is secured by loans receivable of IFSL and is rated CARE PP MLD A+ Stable."
        },
        // {
        //   question: "What will be the Annualized Returns on the MLD?",
        //   answer: "The Minimum Annualized returns would be 0% and the Max. Annualized returns would be xx%."
        // },
      ],
  }
  
  export default aboutbalMLD;